/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-controller-access-in-routes, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class BasicDetailsRoute extends Route {
  // Services
  @service
  router;

  @service
  session;

  @service
  store;

  model() {
    // Reload the school record to pull any external changes.
    return this.store.findRecord('school', this.get('session.activeSchool'), {
      reload: true,
    });
  }

  init() {
    super.init(...arguments);

    this.router.on('routeDidChange', (transition) => {
      if (transition.to.find((route) => route.name === this.routeName)) {
        this.controller.initRecord();
        this.controller.resetDetails();
      }
    });
  }
}
